
export default function HonorsSection() {
  const honors = [
    {
      title: '普洱茶年份茶全国销量第一品牌',
      issuer: '尚普咨询权威认证',
      year: '2020-2024',
      icon: 'ri-trophy-fill',
      image: 'https://public.readdy.ai/ai/img_res/d43cd8bf410a9146a548200219181831.jpg'
    },
    {
      title: '国宾伴手礼认证',
      issuer: '丝路沿线国家指定',
      year: '2023',
      icon: 'ri-medal-fill',
      image: 'https://readdy.ai/api/search-image?query=Official%20diplomatic%20gift%20certificate%20for%20Chinese%20tea%20products%2C%20prestigious%20government%20recognition%20document%2C%20elegant%20formal%20certificate%20with%20national%20emblems%2C%20professional%20ceremonial%20presentation%2C%20high-quality%20institutional%20award%20photography&width=300&height=200&seq=honor-2&orientation=landscape'
    },
    {
      title: '七星茶王奖',
      issuer: '中国茶叶协会',
      year: '2023',
      icon: 'ri-star-fill',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20tea%20association%20seven-star%20tea%20king%20award%20trophy%2C%20prestigious%20golden%20trophy%20with%20star%20design%2C%20professional%20award%20ceremony%20photography%2C%20elegant%20ceremonial%20presentation%20with%20traditional%20Chinese%20tea%20elements&width=300&height=200&seq=honor-3&orientation=landscape'
    },
    {
      title: 'PICC产品责任险承保',
      issuer: '中国人民保险',
      year: '2021-至今',
      icon: 'ri-shield-check-fill',
      image: 'https://readdy.ai/api/search-image?query=Professional%20insurance%20certificate%20from%20PICC%20for%20product%20liability%20coverage%2C%20official%20corporate%20insurance%20document%2C%20formal%20business%20certification%20with%20company%20logos%2C%20professional%20documentation%20photography&width=300&height=200&seq=honor-4&orientation=landscape'
    },
    {
      title: '茶叶质量安全示范企业',
      issuer: '国家质检总局',
      year: '2022',
      icon: 'ri-award-fill',
      image: 'https://readdy.ai/api/search-image?query=National%20quality%20inspection%20bureau%20tea%20safety%20demonstration%20enterprise%20certificate%2C%20official%20government%20quality%20award%20document%2C%20professional%20corporate%20recognition%20certificate%20with%20official%20seals%2C%20high-end%20business%20documentation&width=300&height=200&seq=honor-5&orientation=landscape'
    },
    {
      title: '云南省茶叶龙头企业',
      issuer: '云南省农业厅',
      year: '2021',
      icon: 'ri-building-2-fill',
      image: 'https://readdy.ai/api/search-image?query=Yunnan%20provincial%20agriculture%20department%20leading%20tea%20enterprise%20certificate%2C%20official%20provincial%20government%20recognition%20document%2C%20prestigious%20business%20award%20with%20regional%20authority%20seals%2C%20professional%20corporate%20certification%20photography&width=300&height=200&seq=honor-6&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-[#f5f5f5]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            荣誉见证
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            权威认证，实力见证品质
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {honors.map((honor, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-[#cc9966]/20">
              {/* 荣誉图片 */}
              <div className="mb-6 relative overflow-hidden rounded-lg">
                <img
                  src={honor.image}
                  alt={honor.title}
                  className="w-full h-32 object-cover object-top"
                />
                <div className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className={`${honor.icon} text-sm text-white`}></i>
                </div>
              </div>
              
              {/* 荣誉信息 */}
              <div className="space-y-3">
                <h3 className="text-sm sm:text-base lg:text-lg font-bold text-[#663333] leading-tight">
                  {honor.title}
                </h3>
                
                <div className="flex items-center justify-between">
                  <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">
                    {honor.issuer}
                  </p>
                  <span className="text-xs bg-[#cc9966] text-white px-2 py-1 rounded-full">
                    {honor.year}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 成就统计 */}
        <div className="mt-16 bg-white rounded-2xl p-8 lg:p-12 shadow-lg border border-[#cc9966]/20">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333] text-center mb-8">
            成就数据
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">15+</div>
              <div className="text-xs sm:text-sm text-gray-600">权威认证</div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">50+</div>
              <div className="text-xs sm:text-sm text-gray-600">行业奖项</div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">5</div>
              <div className="text-xs sm:text-sm text-gray-600">国家级荣誉</div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">100%</div>
              <div className="text-xs sm:text-sm text-gray-600">质量合格率</div>
            </div>
          </div>
        </div>

        {/* 未来展望 */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#663333] to-[#cc9966] rounded-2xl p-8 lg:p-12 text-white">
            <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold mb-4">
              未来展望
            </h3>
            <p className="text-sm sm:text-lg lg:text-xl leading-relaxed max-w-4xl mx-auto">
              我们将继续秉承"三真"承诺，不断完善年份茶标准体系，
              致力于成为全球最具影响力的年份茶品牌，
              让世界品味中华茶文化的深厚底蕴。
            </p>
            <div className="mt-6 w-24 h-1 bg-white/30 mx-auto"></div>
          </div>
        </div>
      </div>
    </section>
  );
}